import * as React from 'react';

import styles from './styles.module.scss';

type Props = {
	value: Nullable<string>;
	onImageClick: (imageSrc: string) => void;
};

const FieldReportBlockImageField: React.FC<Props> = ({ value, onImageClick }) => {
	const onClick = React.useCallback(() => {
		if (value) {
			onImageClick(value);
		}
	}, [onImageClick, value]);

	return (
		<>
			{!!value
				? <img className={styles['side-panel-modal__field__image']} onClick={onClick} src={value} />
				: 'None'
			}
		</>
	);
};

export default React.memo(FieldReportBlockImageField);
